<div class="mt-2 my-2 relative">
  <div class="form-field">
    @if (!isTextArea) {
      <input
        #inputElement
        [type]="type"
        [formControl]="formControl"
        [ngClass]="{ filled: control.value }"
        (input)="onInputChange($event)"
      />
      <label class="pointer-events-none">{{ placeholder }}</label>
    } @else {
      <textarea
        [formControl]="formControl"
        [ngClass]="{ filled: control.value }"
        (input)="onInputChange($event)"
      ></textarea>
    }
    <fa-icon class="valid-mark" size="sm" [icon]="faCheckCircle" />
  </div>
  @if (control.invalid && control.touched) {
    @if (control.errors?.["required"]) {
      <span class="text-red-500 text-sm">{{
        "shared.validation.required" | translate
      }}</span>
    } @else if (control.errors?.["email"]) {
      <span class="text-red-500 text-sm">{{
        "shared.validation.emailInvalid" | translate
      }}</span>
    } @else if (control.errors?.["minlength"]) {
      <span class="text-red-500 text-sm">{{
        "shared.validation.minLength"
          | translate: { length: control.errors!["minlength"]?.requiredLength }
      }}</span>
    } @else if (control.errors?.["maxlength"]) {
      <span class="text-red-500 text-sm">{{
        "shared.validation.maxLength"
          | translate: { length: control.errors!["maxlength"]?.requiredLength }
      }}</span>
    } @else if (control.errors?.["whitespace"]) {
      <span class="text-red-500 text-sm">{{
        "shared.validation.noWhitespace"
          | translate: { length: control.errors!["maxlength"]?.requiredLength }
      }}</span>
    } @else {
      <span class="text-red-500 text-sm">{{
        "shared.validation.invalidField" | translate
      }}</span>
    }
  }
</div>
